import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'reducers/rootReducer'

export const store = configureStore({
    reducer: {
        ...rootReducer,
    },
    devTools: process.env.NODE_ENV === `development`,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }),
})
